import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import WidgetHeader from '../Widget/WidgetHeader';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';

import { setOverlayPartnerVisible, onGoToNextCard } from '../Widget/actions';
import { onCompleteLink } from './actions';

import { isLongText } from '../../components/Shared/commonFunctions';
import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import ShareDrawer from '../../components/ShareDrawer';
import { Container } from '../../containers/DefaultStyles/Details';
import {
    DetailsContainer,
    Footer,
    Title,
    Description,
    Content,
    Details,
    Body
} from '../DefaultStyles/Shared';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import { getActionCompletedTime } from '../../utils/actionTiming';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { CardTypes } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

const LinkDetails = props => (
    <Container>
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <Body>
            <WidgetHeader />
            <Content
                isContactAction={true}
                useLocalRepresentative={false}
                isSingleAction={true}
            >
                <Title
                    isLocalRepLoading={false}
                    isLongText={isLongText(props.cardTitle, 40)}
                    isExtraLongText={isLongText(props.cardTitle, 95)}
                    onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                    dangerouslySetInnerHTML={{
                        __html: props.cardTitle
                    }}
                />
                <DetailsContainer>
                    <Details>
                        <Description
                            dangerouslySetInnerHTML={{ __html: props.linkText }}
                            onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                        />
                    </Details>
                </DetailsContainer>
            </Content>
            <AutoScalingButtonSet>
                {props.actions.map(a => (
                    <LocalRepAction
                        action={a}
                        label={a.label}
                        key={a.identifier}
                        onClick={() => {
                            window.open(props.linkUrl, '_blank');
                            props.onCompleteLink(
                                props.apiRequestData,
                                props.actionCompletedTime(),
                                props.actionIdentifier
                            );
                            if (props.nextAction) {
                                props.onGoToNextCard(
                                    props.nextAction.identifier,
                                    props.nextAction.type,
                                    props.nextCard.type === CardTypes.multipleActions ||
                                        props.nextCard.type === CardTypes.multiDonation,
                                    props.nextCard.type === CardTypes.targetedMultiAction,
                                    props.nextAction.skipFrontCard
                                );
                            }
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
            <Footer>
                <ShareDrawer backgroundColor={'#fff'} />
            </Footer>
        </Body>
    </Container>
);

LinkDetails.propTypes = {
    actions: PropTypes.array.isRequired,
    linkText: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    onCompleteLink: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    nextAction: PropTypes.object,
    onGoToNextCard: PropTypes.func.isRequired,
    nextCard: PropTypes.object
};

const specifyProtocol = url =>
    url
        ? url.indexOf('http://') === 0 || url.indexOf('https://') === 0
            ? url
            : 'http://' + url
        : '';

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );
        return {
            actions: state.widget.actions
                .filter(a => a.id === state.widget.activeAction.id)
                .map(a => {
                    return {
                        ...a,
                        label:
                            a.customButtonText ||
                            copyFor('multiactionCard', 'button', 'link')
                    };
                }),
            linkText: state.widget.activeAction.name,
            linkUrl:
                (window || {}).clickTAG || specifyProtocol(state.widget.activeAction.url), // first choice is URL provided by ad servers
            cardTitle:
                state.widget.activeAction.customHeader ||
                copyFor('multiactionCard', 'title', 'link'),
            actionIdentifier: state.widget.activeAction.identifier,
            apiRequestData: state.widget.apiRequestData,
            actionCompletedTime: getActionCompletedTime(state, 'link'),
            nextAction,
            nextCard: nextAction ? state.widget.cards[nextAction.order - 1] : null
        };
    },
    {
        onCompleteLink,
        setOverlayPartnerVisible,
        onGoToNextCard
    }
)(LinkDetails);



// WEBPACK FOOTER //
// ./src/containers/Link/LinkDetails.jsx